import { Util } from '@/modules/util'
import type { ContractRevision } from '@/types/contract'
import { Request } from '@/classes/Request.ts'

export const tuitionContract = async (studentAccountId: TStudentAccountId) => {
  const response = await new Request().get(
    '/ajax/student/' + studentAccountId + '/contract_revisions/signed'
  )
  return Util.Obj.keysToCamel(response.data.contract_revisions) as ContractRevision[]
}
